export default __webpack_public_path__ + "static/machineTranslation-fcd0f35a20fb37cc04923cf88802b29f.png";